<template src="./index.html"></template>
<script>
import data from './data.js';
export default {
	props: {
		copy_Name: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			tableData_picName: [],
			likeSearch: '',
			page: 1, //第几页
			limit: 10,
			search: {
				danjh: '',
				id: '',
				goufmc: '',
				shangpmc: '',
				danjrq: '',
				jiashj: ''
			},
			radio_Name: 0,
			chooseallkh: {},
			total: ''
		};
	},
	created() {},
	mounted() {},
	watch: {
		copy_Name: function(indexVal, oldVal) {
			if (indexVal) {
				this.chooseallkh = {};
				this.page = 1;
				this.limit = 10;
				this.radio_Name = 0;
				this.likeSearch = '';
				this.total = 0;
				this.getCustomerList();
			}
		}
	},
	methods: {
		/* 发票选择客户主数据 */
		radiochangekhClick(row, column, event) {
			this.radio_Name = row.index;
			this.chooseallkh = row;
		},
		/* 发票选择客户主数据 */
		radiochangekh(val) {
			this.chooseallkh = val;
		},
		/* 客户主数据分页 */
		handleSizeChange(val) {
			this.pagenum = val;
			this.getCustomerList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.getCustomerList();
		},
		/* 客户主数据列表数据搜索 */
		forserchgroup() {
			this.getCustomerList();
		},
		/* 关闭客户主数据弹框 */
		closecopy_Name() {
			this.$emit('closecopy_Name', '');
		},
		/* 客户主数据选择 */
		copytkfade() {				
			let params = this.chooseallkh.id;
			this.$https.fetchPost('felec/positiveInvoice/getDocInformById', params).then(res => {
				if (res.data.code == '200') {
					this.$emit('copytkfade', res.data.data);
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		copytkfadeDblclick(row, column, event) {
			console.log(row.id)
			let params = row.id;
			this.$https.fetchPost('felec/positiveInvoice/getDocInformById', params).then(res => {
				if (res.data.code == '200') {
					this.$emit('copytkfade', res.data.data);
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/*  获取客户主数据列表数据*/
		getCustomerList() {
			let patea = {
				limit: this.pagenum,
				page: this.page
				// param: JSON.parse(JSON.stringify(this.searchdata))
			};
			this.$https.fetchPost('felec/positiveInvoice/getDocList', patea).then(res => {
				if (res.data.code == '200') {
					for (let i = 0; i < res.data.data.length; i++) {
						res.data.data[i].index = i + 1;
					}
					this.tableData_picName = res.data.data;
					this.total = res.data.count;
				} else {
					this.$message.error('失败');
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
